import { Skeleton } from "@mui/material";
import React, { useEffect, useState } from "react";
import api from "../../api/api";
import { useParams } from "react-router-dom";
import AddIcon from "@mui/icons-material/Add";
import SaveIcon from "../../../src/assets/orders/Save.svg";
import { useDispatch, useSelector } from "react-redux";
import { addIcon, heartIcon, starIcon } from "./svg";
import { setConfig } from "../../reduxtoolkit/userconfigslice";
const ScheduleButtons = ({
  data,
  userdata,
  selectedCard,
  loading,
  dt,
  selectedSuggestionList,
  fetchsuggestions,
}) => {
  const [selectedTabs, setSelectedTabs] = useState([]);
  const [selectedAddTabs, setSelectedAddTabs] = useState(false);

  const practiseid = window.getPracticeId();

  const tovValue = useSelector(
    (state) => state.dump.storedvalues.find((item) => item.id === "tov")?.value
  );

  const lovValue = useSelector(
    (state) => state.dump.storedvalues.find((item) => item.id === "lov")?.value
  );
  const dispatch=useDispatch()
 const userConfig = useSelector((state) => state.userconfig);
let fav=userConfig?.config?.fav_schedules||[]
  useEffect(() => {
    if (
      !Array.isArray(selectedSuggestionList) ||
      selectedSuggestionList.length === 0
    ) {
      setSelectedTabs([]); // Clear the selected tabs if the suggestion list is invalid or empty
      return;
    }

    const selectedItems = data
      .map((item) =>
        selectedSuggestionList.some(
          (suggestion) => suggestion.ordername === item.content
        )
          ? item.content
          : null
      )
      .filter((content) => content !== null); // Filter out null values

    setSelectedTabs(selectedItems);
  }, [data, selectedSuggestionList]);

  console.log("Userdata", selectedSuggestionList);

  const handleTabClick = async (itemContent) => {
    const isSelected = selectedTabs.includes(itemContent);
    const orderType = ["STREP TEST", "FLU TEST", "COVID TEST"].includes(
      itemContent
    )
      ? "Diagnostic test"
      : "Schedule-RTO";
    try {
      if (isSelected) {
        // Call delete API
        const orderToDelete = selectedSuggestionList.find(
          (x) => x.ordername === itemContent
        );

        if (orderToDelete) {
          const deleteResponse = await api.delete(
            `/v1/${practiseid}/orders/delete/order/${orderToDelete.ordre_id}`,
            {
              data: {
                // orderdate:  userdata.created_at?new Date(userdata.created_at).toISOString().split('T')[0]: "Invalid date",
                orderdate:
                  dt && dt.includes(" ") && !isNaN(Date.parse(dt.split(" ")[0]))
                    ? dt.split(" ")[0]
                    : new Date().toISOString().split("T")[0],
              },
            }
          );
          console.log("Delete API Response:", deleteResponse.data);
        } else {
          console.error("Order ID not found for deletion");
        }
      } else {
        const createResponse = await api.post(
          `/v1/${practiseid}/patient/${userdata.patientid}/orders/create`,
          {
            department_id: 1,
            patient_name: `${userdata.firstname || ""} ${
              userdata.lastname || ""
            }`.trim(),
            tov: tovValue, // purpose
            lov: userdata.lov,
            diagnosis: "",
            ordertype: orderType, // tabs
            ordername: itemContent, // buttons
            schedule: selectedCard, // t/f-schedule
            // provider: userdata.linked_provider,
            provider: `${userConfig?.firstname || ""} ${userConfig?.lastname || ""}`,
            status: "CREATED",
            confirm_status: "E", // C/E
            orderdate:
              dt && dt.includes(" ") && !isNaN(Date.parse(dt.split(" ")[0]))
                ? dt.split(" ")[0]
                : new Date().toISOString().split("T")[0],
            encounterid: 0,
          }
        );
      }

      // Update state after the API call
      setSelectedTabs((prevSelected) => {
        if (isSelected) {
          // Deselect if already selected
          return prevSelected.filter((content) => content !== itemContent);
        } else {
          // Select if not already selected
          return [...prevSelected, itemContent];
        }
      });
      fetchsuggestions();
    } catch (error) {
      console.error("Error in handleTabClick:", error);
    }
  };

  let isLoadingInHouseLabs = false; // This will track whether the function is already running
 const inHouseLabsContent = [
      "CBC",
      "A1C",
      "CMP",
      "LIPIDS",
      "MAGNESIUM",
      "URIC ACID",
      "THYROID PANEL",
      "VIT D",
      "VIT B12",
      "TESTO",
    ];
  const handleInHouseLabsClick = async () => {
    if (isLoadingInHouseLabs) return; // Prevent double-clicking if already loading
    isLoadingInHouseLabs = true; // Set loading to true to prevent further invocations

   
    try {
      // Filter out the items that are already in selectedTabs
      const itemsToAdd = inHouseLabsContent.filter(
        (content) =>
          !selectedTabs.includes(content) &&
          !selectedSuggestionList.some((item) => item.ordername === content)
      );

      if (itemsToAdd.length > 0) {
        // Call handleTabClick for all items that are not in selectedTabs in parallel
        await Promise.all(itemsToAdd.map((content) => handleTabClick(content)));

        // Update selectedTabs with the newly added items
        selectedTabs.push(...itemsToAdd);
      }
    } catch (error) {
      console.error("Error in handleInHouseLabsClick:", error);
    } finally {
      isLoadingInHouseLabs = false; // Reset the loading state after the operation is complete
    }
  };

  let isLoading = false; // This will track whether the function is already running
const stripfluContent = ["STREP TEST", "FLU TEST", "COVID TEST"];
  const handleStrepFluCovidClick = async () => {
    if (isLoading) return; // Prevent double-clicking if already loading
    isLoading = true; // Set loading to true to prevent further invocations

    

    try {
      // First, filter out the items that are already in selectedTabs or selectedSuggestionList
      const itemsToAdd = stripfluContent.filter(
        (content) =>
          !selectedTabs.includes(content) &&
          !selectedSuggestionList.some((item) => item.ordername === content)
      );

      if (itemsToAdd.length > 0) {
        // Call handleTabClick for all items that are not in selectedTabs or selectedSuggestionList in parallel
        await Promise.all(itemsToAdd.map((content) => handleTabClick(content)));
      }
    } catch (error) {
      console.error("Error in handleStrepFluCovidClick:", error);
    } finally {
      isLoading = false; // Reset the loading state after the operation is complete
    }
  };

  console.log("Selected Suggestion List:", selectedSuggestionList);
const updateFavLabs = async (lab) => {
  try {
    let updatedFavs = [...fav];
    if (!updatedFavs.includes(lab)) {
      updatedFavs.push(lab);
    }

   const response= await api.put(`/v1/${practiseid}/user/config`, {
      rowid: userConfig.id,
      fav_schedules: updatedFavs,
    });
 if (response.status === 200) {
      // Update Redux state with the new config
      dispatch(setConfig({
        ...userConfig,
        config: {
          ...userConfig.config,
         fav_schedules: updatedFavs,
        },
      }));
    }
    console.log("Fav labs updated:", updatedFavs);
  } catch (error) {
    console.error("Error updating fav labs:", error);
  }
};
const removeFavbutton = async (lab) => {
  try {
    // Create a new array without the lab to remove
    const updatedFavs = fav.filter((l) => l !== lab);

    // Update the server
    const response = await api.put(`/v1/${practiseid}/user/config`, {
      rowid: userConfig.id,
      fav_schedules: updatedFavs,
    });

    if (response.status === 200) {
      // Update Redux state
      dispatch(setConfig({
        ...userConfig,
        config: {
          ...userConfig.config,
          fav_schedules: updatedFavs,
        },
      }));
    }

    console.log("Fav labs updated:", updatedFavs);
  } catch (error) {
    console.error("Error removing fav lab:", error);
  }
};
const handlebuttonclick = async (x) => {
  if (isLoading) return; // Prevent multiple clicks
  isLoading = true;

  try {
    const contentToAdd = x; // Assuming it's a string

    if (!selectedTabs.includes(contentToAdd) &&
        !selectedSuggestionList.some((item) => item.ordername === contentToAdd)) {
      await handleTabClick(contentToAdd);
      selectedTabs.push(contentToAdd);
    }
  } catch (error) {
    console.error("Error in handleStrepFluCovidClick:", error);
  } finally {
    isLoading = false;
  }
};
  return (
    <div className="flex w-full items-center justify-center flex-wrap ">
      {!!selectedAddTabs && (
        <div className="flex px-16 flex-wrap justify-start mb-3">
          {data
            .filter(
              (x) =>
                x.content !== "INHOUSE LABS-MALE" &&
                x.content !== "INHOUSE LABS-FEMALE"&& !fav.includes(x.content)
            )
            .map((item) => (
              <div
                key={item.content}
                        onClick={() => updateFavLabs(item.content)}
                className={`cursor-pointer text-[11px] gap-1  font-inter tracking-tigh text-center rounded-[10px] border-[1.5px] border-[#E5E7EB] flex items-center justify-center transition-colors duration-300 ease-in-out bg-white text-[#1D2951 hover:!bg-[#E17954] hover:text-white px-2 h-[33px]`}
                style={{ margin: "8px" }}
              >
                {heartIcon}
                {item.content}
              </div>
            ))}
        </div>
      )}
      {loading ? (
        // Display skeletons while loading
        Array.from({ length: 3 }).map((_, index) => (
          <Skeleton
            key={index}
            variant="rectangular"
            width={100}
            height={35}
            style={{ margin: "8px", borderRadius: "50px" }}
          />
        ))
      ) : data.length > 0 ? (
        <>
          {/* Display specific buttons in a separate container */}
          <div className="w-full px-20 flex items-center py-0 mb-2 ">
            {starIcon}
            <div className="font-Font1 text-[#1E2A4A] ml-1 font-inter  text-left">
              Favorites
            </div>
            <div className="flex  w-full items-center ">
              {data
                .filter(
                  (item) =>
                    item.content === "INHOUSE LABS-MALE" ||
                    item.content === "INHOUSE LABS-FEMALE"
                )
                .map((item) => (
                  <div
                    key={item.content}
                    onClick={() => handleTabClick(item.content)}
                    className={`cursor-pointer  text-[12px] font-Font1 font-semibold tracking-tigh text-center rounded-[10px] border-[1.5px] border-gray-200 flex items-center justify-center transition-colors duration-300 ease-in-out ${
                      selectedTabs.includes(item.content)
                        ? "bg-[#E17954] text-white"
                        : "text-[#1D2951] bg-white"
                    }  hover:!bg-[#E17954] hover:text-white px-3 h-[30px] mx-1`}
                  >
                    <img
                      src={SaveIcon}
                      style={{ marginRight: "5px" }}
                      alt="&/"
                    />
                    {item.content}
                  </div>
                ))}
             {/* <div
  onClick={handleInHouseLabsClick}
  className={`cursor-pointer text-[12px] mx-1 my-1 font-Font1 font-semibold tracking-tight text-center rounded-[10px] border-[1.5px] border-gray-200 flex items-center justify-center transition-colors duration-300 ease-in-out px-3 h-[30px]
    ${
      inHouseLabsContent.every((test) =>
        selectedSuggestionList.some(item => item.ordername === test)
      )
        ? "bg-[#E17954] text-white"
        : "bg-white text-[#374151] hover:!bg-[#E17954] hover:text-white"
    }`}
>
                <img src={SaveIcon} style={{ marginRight: "5px" }} alt="&/" />
                INHOUSE LABS
              </div> */}
         {/* <div
  onClick={handleStrepFluCovidClick}
  className={`cursor-pointer text-[12px] mx-1 my-1 font-Font1 font-semibold tracking-tight text-center rounded-[10px] border-[1.5px] border-gray-200 flex items-center justify-center transition-colors duration-300 ease-in-out px-3 h-[30px]
    ${
      stripfluContent.some(test =>
        selectedSuggestionList.some(item => item.ordername === test)
      )
        ? "bg-[#E17954] text-white"
        : "bg-white text-[#374151] hover:!bg-[#E17954] hover:text-white"
    }`}
>
                <img src={SaveIcon} style={{ marginRight: "5px" }} alt="&/" />
                Strep/flu/Covid
              </div> */}
               <div className="flex ml-2 flex-wrap justify-start gap-2">
{fav.map((lab) => {
  const isSelected = selectedTabs.includes(lab);

  return (
    <div
      key={lab}
      onClick={() => handlebuttonclick(lab)}
      className={`${
        isSelected ? 'bg-[#E17954] text-white border-[#E17954]' : 'bg-white text-[#374151] border-[#E5E7EB]'
      } hover:!bg-[#E17954] hover:text-white cursor-pointer text-[12px] mx-1 my-1 font-Font1 font-semibold tracking-tight text-center rounded-[10px] flex items-center justify-center transition-colors duration-300 ease-in-out px-3 h-[30px]`}
    >
      <span className="mr-1">{lab}</span>
      <span
        className="text-[#9CA3AF] hover:text-white font-bold ml-1 cursor-pointer"
        onClick={(e) => {
          e.stopPropagation(); // Prevent parent div click
          removeFavbutton(lab);
        }}
      >
        ×
      </span>
    </div>
  );
})}



</div>
              <button
               className="focus:outline-none relative group"
                onClick={() => setSelectedAddTabs((prev) => !prev)}
              >
                <div
                  className={`transition-transform duration-300 ease-in-out ${
                    selectedAddTabs
                      ? "rotate-45 text-red-500"
                      : "rotate-0 text-[#E17954]"
                  }`}
                >
                  {addIcon}
                </div>
                  <span className="absolute top-[40px] left-1/2 -translate-x-1/2 bg-[#1D2951] text-white text-xs font-medium py-1 px-2 rounded-md opacity-0 group-hover:opacity-100 transition-all duration-200 whitespace-nowrap pointer-events-none z-50">
    Add Favourites
  </span>
              </button>
            </div>
          </div>

          {/* Display remaining buttons in another container */}
          <div className="flex px-16 flex-wrap justify-start">
            {data
              .filter(
                (x) =>
                  x.content !== "INHOUSE LABS-MALE" &&
                  x.content !== "INHOUSE LABS-FEMALE"
              )
              .map((item) => (
                <div
                  key={item.content}
                  onClick={() => handleTabClick(item.content)}
                  className={`cursor-pointer text-[11px]  font-inter tracking-tigh text-center rounded-[10px] border-[1.5px] border-gray-200 flex items-center justify-center transition-colors duration-300 ease-in-out ${
                    selectedTabs.includes(item.content)
                      ? "bg-[#E17954] text-white"
                      : "text-[#1D2951] bg-white"
                  }  hover:!bg-[#E17954] hover:text-white px-3 h-[33px]`}
                  style={{ margin: "8px" }}
                >
                  {item.content}
                </div>
              ))}
          </div>
        </>
      ) : (
        // Display "No suggestions found" message when data is empty
        <p className="text-center text-gray-500">No suggestions found</p>
      )}
    </div>
  );
};

export default ScheduleButtons;
